import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialModule } from '@material/material.module';

import { BatchOperationRejectCandidateComponent } from './components/batch-operation-reject-candidate.component';

const components = [
  BatchOperationRejectCandidateComponent,
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    MaterialModule,
  ],
  exports: components,
})
export class BatchOperationRejectCandidateModule { }
